import { URLSearchParams } from '@angular/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import {
    ConfiguracoesProjeto,
    GenericHttpService, ParametrosService, PaginatedList
} from '../../../shared/index';
import { ConsumidorModel } from './consumidor.model';
import { ConsumidorService } from './consumidor.service';
import { BilheteConsumidorModel } from './consumidor-bilhetes.model';
import { LoadingService } from '../../../shared-layout/loading/loading.service';
import { Subscription } from 'rxjs/Subscription';
import { ResultadoBilhetePrevisaoModel } from '../../../shared/model/resultado_bilhete_previsao.model';
import { AgrupamentoMensalBilheteModel } from '../../../shared/model/agrupamento-mensal-bilhete.model';
import { FiltroListagemAgrupamentoMensalBilheteModel } from '../../../shared/model/filtro-listagem-agrupamento-mensal-bilhete.model';
import { DetalheAgrupamentoMensalBilheteModel } from '../../../shared/model/detalhe-agrupamento-mensal-bilhete.model';
import { FiltroListagemDetalheAgrupamentoMensalBilheteModel } from '../../../shared/model/filtro-listagem-detalhe-agrupamento-mensal-bilhete.model';
import { FiltroObterBilhetesSorteioConsumidor } from '../../../shared/model/filtro-obter-bilhetes-sorteio-consumidor';
import { FiltroListagemBilhetesComPrevisao } from '../../../shared/model/filtro-listagem-bilhetes-com-previsao';
import { StatusRequisicao } from '../../../shared/model/status-requisicao';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { OperatorFunction } from 'rxjs/interfaces';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class BilheteConsumidorService {

    public urlBase: string;
    [x: string]: any;

    public bilhetes: BilheteConsumidorModel[];
    public totalBilhetes = 0;
    public bilhetesChange = new Subject<BilheteConsumidorModel[]>();

    public ListagemAgrupamentoMensalBilheteChange: Subject<AgrupamentoMensalBilheteModel[]> = new Subject<AgrupamentoMensalBilheteModel[]>();
    public ListagemDetalheAgrupamentoMensalBilheteChange: Subject<DetalheAgrupamentoMensalBilheteModel[]> = new Subject<DetalheAgrupamentoMensalBilheteModel[]>();
    public agrupamentoMensalBilhete: AgrupamentoMensalBilheteModel[];

    // Mensal
    public totalBilhetesMensal = 0;
    public previsaoBilhetesMensal = 0;
    public nomeSorteioMensal : string;
    public bilhetesMensal: BilheteConsumidorModel[];
    public bilhetesMensalChange = new Subject<BilheteConsumidorModel[]>();
    public bilhetesGeradosMensal: boolean;


      // Especial
    public totalBilhetesEspecial = 0;
    public previsaoBilhetesEspecial = 0;
    public nomeSorteioEspecial : string;
    public bilhetesEspecial: BilheteConsumidorModel[];
    public bilhetesEspecialChange = new Subject<BilheteConsumidorModel[]>();
    public bilhetesGeradosEspecial: boolean;

    public consumidor: ConsumidorModel;
    public configuracao: ConfiguracoesProjeto;

    public MensagemErro: string = null;

    private messageSourceMensal = new BehaviorSubject('');
    currentMessageMensal = this.messageSourceMensal.asObservable();

    private messageSourceEspecial = new BehaviorSubject('');
    currentMessageEspecial = this.messageSourceEspecial.asObservable();

    constructor(
        private readonly genericHttpService: GenericHttpService<BilheteConsumidorModel>,
        private readonly genericHttpServiceMensal: GenericHttpService<BilheteConsumidorModel>,
        private readonly genericHttpServiceEspecial: GenericHttpService<BilheteConsumidorModel>,
        private readonly genericHttpServiceAgrupamentoMensalBilhete: GenericHttpService<AgrupamentoMensalBilheteModel>,
        private readonly genericHttpServiceDetalheAgrupamentoMensalBilhete: GenericHttpService<DetalheAgrupamentoMensalBilheteModel>,
        private readonly consumidorService: ConsumidorService,
        private readonly parametrosService: ParametrosService,
        private readonly loadingService: LoadingService,
        private readonly loadingServiceMensal: LoadingService
    ) {

        this.consumidorService.consumidorChange.subscribe(
            (cons: ConsumidorModel) => {
                this.consumidor = cons;
            }
        );

        this.consumidorService.getConsumidorModel();

        this.configuracao = this.parametrosService.getConfiguracao();
        this.urlBase = this.configuracao.uri + 'bilhetes';
    }

    public getBilhetesSorteioConsumidor(filtro: FiltroObterBilhetesSorteioConsumidor): void {
      const url = `${this.urlBase}/listagem-bilhetes-sorteio-consumidor`;

      this.getListagemCompletaBilhetesGerados(url, filtro);
  }

    getListagemCompletaBilhetesGerados(url: string, filtro: FiltroObterBilhetesSorteioConsumidor) {
 
      this.loadingService.exibirLoading('Aguarde, consultando seus bilhetes.');
      let parametrosBusca = this.obterParametrosBuscaBilhetesSorteioConsumidor(filtro);

        this.genericHttpService.getAny(url, parametrosBusca)
            .subscribe(
                (data: PaginatedList<BilheteConsumidorModel>) => {
                    this.bilhetes = data.list;
                    this.totalBilhetes = data.totalCount;
                    this.bilhetesChange.next(this.bilhetes.slice());
                },
                (error: any) => {
                  this.loadingService.esconderLoading();
                  this.bilhetesChange.next(this.bilhetes.slice());
                },
                () => {
                  this.loadingService.esconderLoading();
                }
        );
  }

      private obterParametrosBuscaBilhetesSorteioConsumidor(filtro: FiltroObterBilhetesSorteioConsumidor) : URLSearchParams {
        const params: URLSearchParams = new URLSearchParams();
        params.append('sorteioId', filtro.sorteioId.toString());
        params.append('consumidorId', filtro.consumidorId.toString());
        params.append('page', filtro.page.toString());
        params.append('pageSize', filtro.pageSize.toString());
        return params;
      }

    public getAgrupamentoMensalBilhete(sorteioId: number): void {

      const url = `${this.urlBase}/listagem-bilhetes-sorteio-especial-por-agrupamento-mensal`;
      let consumidorId: string;

      if (this.consumidor.consumidorId) {
        consumidorId = this.consumidor.consumidorId.toString();
      }

      let filtroListagemAgrupamentoMensalBilheteModel: FiltroListagemAgrupamentoMensalBilheteModel = new FiltroListagemAgrupamentoMensalBilheteModel;
      filtroListagemAgrupamentoMensalBilheteModel.consumidorId = consumidorId;
      filtroListagemAgrupamentoMensalBilheteModel.sorteioId = sorteioId.toString();

      this.getListagemAgrupamentoMensalBilhete(url, filtroListagemAgrupamentoMensalBilheteModel);
    }

    private LimparMensagemErroRequisicaoEspecial() {
      this.messageSourceEspecial.next('');
     }

    public getListagemAgrupamentoMensalBilhete(url: string, filtro: FiltroListagemAgrupamentoMensalBilheteModel): void {
      
      this.LimparMensagemErroRequisicaoEspecial();

      this.loadingService.exibirLoading('Aguarde enquanto os bilhetes estão sendo consultados.');

      let parametrosBusca = this.obterParametrosBuscaAgrupamentoMensalBilhete(filtro);

      const s: Subscription = this.genericHttpServiceAgrupamentoMensalBilhete.getAny(url, parametrosBusca).subscribe(
        (data: AgrupamentoMensalBilheteModel[]) => {
          this.ListagemAgrupamentoMensalBilheteChange.next(data);
        },
        (error: any) => {

          this.ListagemAgrupamentoMensalBilheteChange.next([]);
          this.loadingService.esconderLoading();

          let err = error as StatusRequisicao; 
          this.messageSourceEspecial.next(err.motivo);
        },
        () => {
          s.unsubscribe();
          this.loadingService.esconderLoading();
        }
      );
    }

    private obterParametrosBuscaAgrupamentoMensalBilhete(filtro: FiltroListagemAgrupamentoMensalBilheteModel) : URLSearchParams {
      const params: URLSearchParams = new URLSearchParams();
      params.append('sorteioId', filtro.sorteioId.toString());
      params.append('consumidorId', filtro.consumidorId.toString());
      return params;
    }

    public getDetalheAgrupamentoMensalBilhete(ano: number, mes: number): void {

      const url = `${this.urlBase}/listagem-bilhetes-mensal`;
      let consumidorId: string;

      if (this.consumidor.consumidorId) {
        consumidorId = this.consumidor.consumidorId.toString();
      }

      let filtroListagemDetalheAgrupamentoMensalBilheteModel: FiltroListagemDetalheAgrupamentoMensalBilheteModel = new FiltroListagemDetalheAgrupamentoMensalBilheteModel;
      filtroListagemDetalheAgrupamentoMensalBilheteModel.ano = ano.toString();
      filtroListagemDetalheAgrupamentoMensalBilheteModel.mes = mes.toString();
      filtroListagemDetalheAgrupamentoMensalBilheteModel.consumidorId = consumidorId;

      this.getListagemDetalheAgrupamentoMensalBilhete(url, filtroListagemDetalheAgrupamentoMensalBilheteModel);
    }

    public getListagemDetalheAgrupamentoMensalBilhete(url: string, filtro: FiltroListagemDetalheAgrupamentoMensalBilheteModel): void {
      this.loadingService.exibirLoading('Aguarde enquanto os bilhetes estão sendo consultados.');

      let parametrosBusca = this.obterParametrosBuscaDetaheAgrupamentoMensalBilhete(filtro);

      const s: Subscription = this.genericHttpServiceDetalheAgrupamentoMensalBilhete.getAny(url, parametrosBusca).subscribe(
        (data: DetalheAgrupamentoMensalBilheteModel[]) => {
          this.ListagemDetalheAgrupamentoMensalBilheteChange.next(data);
        },
        (error: any) => {
          this.ListagemDetalheAgrupamentoMensalBilheteChange.next([]);
          this.loadingService.esconderLoading();
        },
        () => {
          s.unsubscribe();
          this.loadingService.esconderLoading();
        }
      );
    }

    private obterParametrosBuscaDetaheAgrupamentoMensalBilhete(filtro: FiltroListagemDetalheAgrupamentoMensalBilheteModel) : URLSearchParams {
      const params: URLSearchParams = new URLSearchParams();
      params.append('ano', filtro.ano.toString());
      params.append('mes', filtro.mes.toString());
      params.append('consumidorId', filtro.consumidorId.toString());
      return params;
    }

    getListaBilhetesComPrevisaoMensal(filtro: FiltroListagemBilhetesComPrevisao) {
 
      const url = this.ObterUrlListarBilhetes();
      const search = this.ObterSearchListarBilhetes(filtro);
 
      this.getListaCompletaBilhetesComPrevisaoMensal(url, search);
    }

    getListaBilhetesComPrevisaoEspecial(filtro: FiltroListagemBilhetesComPrevisao) {
 
      const url = this.ObterUrlListarBilhetes();
      const search = this.ObterSearchListarBilhetes(filtro);

      this.getListaCompletaBilhetesComPrevisaoEspecial(url, search);
   }

   private LimparMensagemErroRequisicaoMensal(){
    this.messageSourceMensal.next('');
   }

    getListaCompletaBilhetesComPrevisaoMensal(url: string, search: any) {

      this.LimparMensagemErroRequisicaoMensal();

        this.loadingServiceMensal.exibirLoading('Aguarde, consultando seus bilhetes.');
      
        this.genericHttpServiceMensal.getAny(url, search)
            .subscribe(
                (data: ResultadoBilhetePrevisaoModel) => {
                    this.bilhetesMensal = data.listagem.list;
                    this.totalBilhetesMensal = data.listagem.totalCount;
                    this.previsaoBilhetesMensal = data.previsaoQuantidadeBilhetes;
                    this.nomeSorteioMensal = data.nomeSorteio;
                    this.bilhetesGeradosMensal = data.bilhetesGerados;
                    this.bilhetesMensalChange.next(this.bilhetesMensal.slice());
                },
                (error: any) => {

                  let err = error as StatusRequisicao; 

                  this.loadingServiceMensal.esconderLoading();

                  this.messageSourceMensal.next(err.motivo);
                },
                () => {
                  this.loadingServiceMensal.esconderLoading();
                }
        );
      }

      getListaCompletaBilhetesComPrevisaoEspecial(url: string, search: any) {

        this.genericHttpServiceEspecial.getAny(url, search)
            .subscribe(
                (data: ResultadoBilhetePrevisaoModel) => {
                    this.bilhetesEspecial = data.listagem.list;
                    this.totalBilhetesEspecial = data.listagem.totalCount;
                    this.previsaoBilhetesEspecial = data.previsaoQuantidadeBilhetes;
                    this.nomeSorteioEspecial = data.nomeSorteio;
                    this.bilhetesGeradosEspecial = data.bilhetesGerados;
                    this.bilhetesEspecialChange.next(this.bilhetesEspecial.slice());
                },
                (error: any) => {

                  let err = error as StatusRequisicao; 
                  this.MensagemErro = err.motivo;
                  this.bilhetesEspecialChange.next([]);
                }
            );
      }

    ObterUrlListarBilhetes() {
      let url = `${this.urlBase}/listagem-bilhetes`;
      return url;
  }

    ObterSearchListarBilhetes(filtro: FiltroListagemBilhetesComPrevisao) {
  
      const params: URLSearchParams = new URLSearchParams();
      params.append('ano', filtro.ano.toString());
      params.append('mes', filtro.mes.toString());
      params.append('tipoSorteio', filtro.tipoSorteio.toString());
      params.append('consumidorId', this.consumidor.consumidorId.toString());
      params.append('page', filtro.page.toString());
      params.append('pageSize', filtro.pageSize.toString());
      return params;
    }
}



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/shared/consumidor-bilhetes.service.ts